/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePartnerBankingAccountV1Dto } from '../models/CreatePartnerBankingAccountV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PartnerBankingAccountV1Dto } from '../models/PartnerBankingAccountV1Dto';
import type { PatchPartnerBankingAccountV1Dto } from '../models/PatchPartnerBankingAccountV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnerBankingAccountsService {
  /**
   * @param requestBody
   * @returns PartnerBankingAccountV1Dto create entity
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1CreateV1(
    requestBody: CreatePartnerBankingAccountV1Dto,
  ): CancelablePromise<PartnerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/partner-banking-accounts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns PartnerBankingAccountV1Dto a entity list
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1FindAllV1(): CancelablePromise<
    Array<PartnerBankingAccountV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partner-banking-accounts',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partner-banking-accounts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid partnerBankingAccountId
   * @returns PartnerBankingAccountV1Dto the entity
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<PartnerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partner-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid partnerBankingAccountId
   * @param requestBody
   * @returns PartnerBankingAccountV1Dto the update entity
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPartnerBankingAccountV1Dto,
  ): CancelablePromise<PartnerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/partner-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid partnerBankingAccountId
   * @returns PartnerBankingAccountV1Dto the entity
   * @throws ApiError
   */
  public static partnerBankingAccountControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<PartnerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partner-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
